import React from 'react';
import { globalStyles } from 'snacks-design-system';
import styles from './OrderDetailAdditionalInformation.module.scss';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIEText from '@src/shared/components/PIEText';
import {
  IconArrowUpLeft,
  IconPinAtHome,
} from '@justeattakeaway/pie-icons-react';
import { useTranslation } from 'react-i18next';

interface componentProps {
  floor: string;
  apartmentNumber: number | string;
  bottomSlot?: React.ReactNode;
}

const { xdsSpacingC } = globalStyles;
export const OrderDetailAdditionalInformation = ({
  floor,
  apartmentNumber,
  bottomSlot,
}: componentProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.OrderDetailAdditionalInformation}>
      <PIEComponentUtil marginBottom={xdsSpacingC}>
        <PIEText
          text={t('order.additional_information')}
          size="var(--xds-font-size-16)"
          fontWeight="var(--xds-font-weight-bold)"
          color="var(--xds-color-content-default"
        />
      </PIEComponentUtil>
      {floor && (
        <PIEComponentUtil marginBottom={xdsSpacingC}>
          <PIEText
            text={
              <>
                <IconArrowUpLeft
                  className={styles.OrderDetailAdditionalInformationIcon}
                  size="m"
                />
                {t('order.order_detail_floor')}: {floor}
              </>
            }
            size="var(--xds-font-size-16)"
            fontWeight="var(--xds-font-weight-regular)"
            color="var(--xds-color-content-default)"
          />
        </PIEComponentUtil>
      )}
      {apartmentNumber && (
        <PIEText
          text={
            <>
              <IconPinAtHome
                className={styles.OrderDetailAdditionalInformationIcon}
                size="m"
              />
              {t('order.order_detail_apartment_number')}: {apartmentNumber}
            </>
          }
          size="var(--xds-font-size-16)"
          fontWeight="var(--xds-font-weight-regular)"
          color="var(--xds-color-content-default)"
        />
      )}
      {bottomSlot && <PIEComponentUtil marginTop={xdsSpacingC}>{bottomSlot}</PIEComponentUtil>}
    </div>
  );
};

export default OrderDetailAdditionalInformation;
